import React from 'react';
import type { MeasurementsFormData } from '../../types';
import { Field, FieldsProps, inputCls } from './fieldParts';

type NumberKey = 'height' | 'weight' | 'headCircumference';
type UnitKey = 'heightUnit' | 'weightUnit' | 'headCircumferenceUnit';

const ROWS: Array<{ key: NumberKey; unit: UnitKey; label: string; units: string[]; placeholder: string }> = [
  { key: 'height', unit: 'heightUnit', label: 'Height', units: ['in', 'cm'], placeholder: '30.5' },
  { key: 'weight', unit: 'weightUnit', label: 'Weight', units: ['lb', 'kg', 'oz'], placeholder: '8.5' },
  { key: 'headCircumference', unit: 'headCircumferenceUnit', label: 'Head Circumference', units: ['in', 'cm'], placeholder: '13.5' },
];

/** Height, weight, head circumference (Phase 18 M1: > 0, blanks not sent) */
const MeasurementsFields: React.FC<FieldsProps<MeasurementsFormData> & { firstRef?: React.Ref<HTMLInputElement> }> = ({
  value, onChange, errors, showRequired, isMobile, disabled, firstRef,
}) => (
  <div className={`grid gap-1.5 ${isMobile ? 'grid-cols-1' : 'grid-cols-3'}`}>
    {ROWS.map((row, i) => {
      const id = `measurements-${row.key}`;
      return (
        <Field key={row.key} id={id} label={row.label} error={errors[row.key]} showRequired={showRequired} labelClassName="text-yellow-700">
          <div className="flex">
            <input
              id={id}
              ref={i === 0 ? firstRef : undefined}
              type="number"
              inputMode="decimal"
              step="0.1"
              disabled={disabled}
              className={`${inputCls({ isMobile, disabled }, Boolean(errors[row.key]))} rounded-r-none`}
              value={value[row.key]}
              placeholder={row.placeholder}
              onChange={(e) => onChange({ ...value, [row.key]: e.target.value })}
            />
            <select
              aria-label={`${row.label} unit`}
              disabled={disabled}
              className={`px-2 ${isMobile ? 'text-base' : 'text-base md:text-sm'} border border-l-0 border-gray-300 rounded-r bg-white focus:outline-none focus:border-blue-500 ${isMobile ? 'py-2.5 min-h-[44px]' : 'py-1'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
              value={value[row.unit]}
              onChange={(e) => onChange({ ...value, [row.unit]: e.target.value })}
            >
              {row.units.map((u) => <option key={u} value={u}>{u}</option>)}
            </select>
          </div>
        </Field>
      );
    })}
  </div>
);

export default MeasurementsFields;
